<template>
  <div :class="classes" v-loading="loading">
    <pt-page-title title="订单详情"> </pt-page-title>
    <template v-if="router_name=='order-detail'&&!isRefundPage">
      <pt-sub-title title="订单状态"></pt-sub-title>
      <order-states :orderDetail="order_detail" :steps="orderStatesArray"></order-states>
    </template>
    <pt-sub-title title="订单信息"></pt-sub-title>
    <order-message :order-detail="order_detail" :goods-data="goodsData" :specifications="specifications" :payment-details="paymentDetails"
                   @closeOrder="closeOrder" @getTdMaxWidth="getTdMaxWidth" :isRenewDeposit="isRenewDeposit"></order-message>
    <patient-message v-if="isShowPetient" :tdMaxWidth="tdMaxWidth" :patient="patientMessage"></patient-message>
    <template v-if="userRegistration&&registrationEvent">
      <pt-sub-title :title="formMessageTitle"></pt-sub-title>
      <health-order-message :userRegistration="userRegistration" :registrationEvent="registrationEvent" @refreshDetail="refreshDetail" :mallOrderId="id" isEdit>
      </health-order-message>
    </template>
		<template v-if="order_detail.type==='CONTRACT'">
			<pt-sub-title title="CPS存储信息"></pt-sub-title>
			<CPS-store-message :order-detail="order_detail" :goods-data="goodsData"></CPS-store-message>
		</template>
    <template v-if="isShowInvoce">
      <pt-sub-title title="发票信息"></pt-sub-title>
      <receipt-table :receiptTableLabels="receiptTableLabels" :order-detail="orderDetail" :invoiceList="invoiceList" @downloadInvoice="downloadInvoice">
      </receipt-table>
    </template>
    <template v-if="placementDetails.parentOrderId || orderHistoryList.length">
      <pt-sub-title title="订单历史"></pt-sub-title>
      <order-history :placementDetails="orderDetail.placementDetails" :orderHistoryList="orderHistoryList"></order-history>
    </template>
    <after-sales-message :goodsData="goodsData" title="订单规则" from="order" :tdMaxWidth="tdMaxWidth"></after-sales-message>
    <template v-if="router_name=='refund-detail'">
      <pt-sub-title title="申请退款信息"></pt-sub-title>
      <apply-refund-message v-if="isShowRefundDetail && !isRefundAppleAgain" :order-detail="order_detail" :refundment-details="refundmentDetails"
                            @refundAppleAgain="refundAppleAgain" :HAS_ORDER_MANAGEMENT="HAS_ORDER_MANAGEMENT" @refreshDetail="refreshDetail">
      </apply-refund-message>
      <apply-refund-form :isApplyAgain="isRefundAppleAgain" v-else :order-detail="order_detail" @cancel="refundCancel"
                         @getRefundmentReason="getRefundmentReason" :refundReasonList="refundReasonList" :refundReasonLoading="refundReasonLoading"
                         :againApplyDetail="refundmentApply"></apply-refund-form>
    </template>
    <template v-else>
      <template v-if="isRefundPage">
        <pt-sub-title title="申请退款信息"></pt-sub-title>
        <template v-if="isShowRefundDetail && !isRefundAppleAgain">
          <apply-refund-message @refundAppleAgain="refundAppleAgain" :order-detail="order_detail" :refundment-details="refundmentDetails"
                                @refreshDetail="refreshDetail"></apply-refund-message>
        </template>
        <template v-else>
          <apply-refund-form :specifications="specifications" :userPoints="userPoints" :order-detail="order_detail" @getRefundmentReason="getRefundmentReason"
                             :refundReasonList="refundReasonList" :refundReasonLoading="refundReasonLoading" :againApplyDetail="refundmentApply">
          </apply-refund-form>
        </template>
      </template>
      <template v-else-if="isShipping">
        <!-- <pt-sub-title title="采样盒信息"></pt-sub-title> -->
        <sampling-message ref="form" @deliver="deliver" :orderId="id" :orderDetail="orderDetail" :isDetail="true"></sampling-message>
      </template>
    </template>
    <div v-if="isAllowClose" class="button-div" style="padding-left:0">
      <el-button type="primary" @click="closeOrder">关闭订单</el-button>
    </div>
  </div>
</template>

<script>
import { orderSteps, receiptTableLabels } from '../goods-order-options.js'
import orderMessage from './order-message'
import orderHistory from './order-history'
import samplingMessage from './sampling-message'
import receiptTable from './receipt-table'
import orderStates from './order-states'
import applyRefundForm from './apply-refund-form'
import applyRefundMessage from './apply-refund-message'
import patientMessage from './patient-message'
import afterSalesMessage from '../../mall-manage/pt-goods-manage/pt-goods-detail/after-sales-message'
import healthOrderMessage from '../health-order-message'
import CPSStoreMessage from "./CPS-store-message.vue"
import { hasPermissions } from 'utils/permissions'
// 操作订单权限
const PERM_MALLSALES_ORDER_MANAGEMENT = 'PERM_MALLSALES_ORDER_MANAGEMENT'
// 组件class前缀
const prefixCls = 'pt-order-detail'

export default {
  name: 'pt-order-detail',

  computed: {
    classes () {
      return `${prefixCls}`
    },
    goodsData () {
      return (this.order_detail && this.order_detail.goods && this.order_detail.goods[0]) || {}
    },
    specifications () {
      return (this.order_detail && this.order_detail.placementDetails && this.order_detail.placementDetails.goods && this.order_detail.placementDetails.goods.specificationItem) || {}
    },
    paymentDetails () {
      return (this.order_detail && this.order_detail.paymentDetails) || {}
    },
    refundmentDetails () {
      return (this.order_detail && this.order_detail.refundmentDetails) || {}
    },
    // 退款的申请信息
    refundmentApply () {
      return this.refundmentDetails.apply || {}
    },
    form () {
      return this.$refs.form
    },
    // 是否显示退款信息（为true时，显示退款详情，false时，显示退款表单）
    isShowRefundDetail () {
      return this.paymentDetails && this.refundmentDetails.status
    },
    // 是否需要发货
    isShipping () {
      return this.orderDetail.orderStatus === 'PAID' && this.orderDetail.requirements && this.orderDetail.requirements.requireShipping &&
      !(this.orderDetail.refundmentDetails && this.orderDetail.refundmentDetails.apply) && this.HAS_ORDER_MANAGEMENT
    },
    // 订单是否可关闭
    isAllowClose () {
      return this.order_detail.orderStatus === 'WAITING_FOR_PAYMENT' && !this.order_detail.isBalanceWaitingPayment
    },

    // 是否需要开票
    isNeedInvoice () {
      return this.order_detail.placementDetails && this.order_detail.placementDetails.needInvoice
    },
    // 是否显示发票信息
    isShowInvoce () {
      return this.isNeedInvoice && !this.isRefundPage && this.invoiceList && this.invoiceList.length > 0
    },
    // 受检人信息
    patientMessage () {
      return this.order_detail.patient || {}
    },
    // 是否显示受检人信息
    isShowPetient () {
      return this.goodsData.type === 'PHYSICAL'
    },
    // 是否显示历史订单
    placementDetails () {
      return this.order_detail.placementDetails || {}
    },
    // 操作订单权限
    HAS_ORDER_MANAGEMENT () {
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_MALLSALES_ORDER_MANAGEMENT)
    },
    // 是否是退款页面
    isRefundPage () {
      return this.operation === 'refund' && this.HAS_ORDER_MANAGEMENT
    },
    formMessageTitle () {
      let title = '动态表单信息'
      switch (this.goodsData.type) {
        case 'OPERATING_EVENT':
          title = '脐荐康订单信息'
          break
        case 'RENEW_DEPOSIT':
          title = '续存订单信息'
          break
        default:
          title = '动态表单信息'
          break
      }
      return title
    },
    isRenewDeposit () {
      return this.registrationEvent && this.registrationEvent.type === 'RENEW_DEPOSIT'
    }
  },
  props: {
    orderDetail: {
      type: Object,
      default: function () {
        return {}
      }
    },
    registrationEvent: {
      type: Object
    },
    userRegistration: {
      type: Object
    },
    operation: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    orderStatesArray: {
      type: Array,
      default: function () {
        return []
      }
    },
    refundReasonList: {
      type: Array,
      default: function () {
        return []
      }
    },
    orderHistoryList: {
      type: Array,
      default: function () {
        return []
      }
    },
    refundReasonLoading: {
      type: Boolean,
      default: false
    },
    invoiceList: {
      type: Array,
      default: function () {
        return []
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    userPoints: Number
  },
  data () {
    return {
      steps: orderSteps,
      receiptTableLabels: receiptTableLabels,
      stepsActive: 1,
      order_detail: this.orderDetail,
      router_name: '',
      // 是否是再次申请
      isRefundAppleAgain: false,
      tdMaxWidth: ''
    }
  },
  components: {
    orderMessage,
    orderHistory,
    samplingMessage,
    receiptTable,
    orderStates,
    applyRefundForm,
    applyRefundMessage,
    afterSalesMessage,
    patientMessage,
    healthOrderMessage,
		CPSStoreMessage
  },
  watch: {
    orderDetail: {
      handler: function (val) {
        this.order_detail = val
        this.isRefundAppleAgain = false
      },
      deep: true
    }

  },
  methods: {
    refreshDetail () {
      this.$emit('refreshDetail')
    },
    downloadInvoice () {
      this.$emit('downloadInvoice')
    },
    getTdMaxWidth (val) {
      this.$nextTick(_ => {
        this.tdMaxWidth = val
      })
    },
    refundCancel () {
      this.isRefundAppleAgain = false
    },
    refundAppleAgain () {
      this.isRefundAppleAgain = true
    },
    getRefundmentReason () {
      this.$emit('getRefundmentReason')
    },
    deliver (val) {
      this.$emit('submit', val)
    },
    closeOrder () {
      this.$emit('closeOrder')
    }
  },
  created () {
    this.router_name = this.$route.name
  }
}
</script>

<style module lang="less">
@import "~less/var";
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
